import React, {useMemo} from 'react'
import {useParams} from 'react-router'
import {useProfile} from 'entities/profile'
import {useUser} from 'entities/user'
import {TextSpoiler} from 'features/textSpoiler'
import styles from './styles.module.scss'

export const ProfileAboutMe = () => {
  const {id} = useParams()
  const profile = useProfile()
  const me = useUser()

  const about = useMemo(() => !!id ? (profile.about || '') : (me.profile.about || ''), [id, profile.about, me.profile.about])

  return (
    <>
      {about
        ? <div className={styles.wrapper}>
          <TextSpoiler text={about} />
        </div>
        : null}
    </>
  )
}